import SettingsCell from './SettingsCell';

export default SettingsCell;
